import { render } from "./WizardsTwo.vue?vue&type=template&id=2f29a28b"
import script from "./WizardsTwo.vue?vue&type=script&lang=js"
export * from "./WizardsTwo.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__